// Generated by format-carbon carbon-class --emit-enums from schema enums.json.

export const GrannyDeprecationLevel = Object.freeze({
  DO_NOTHING: 0,
  LOG_ERROR: 1,
  LOG_ERROR_AND_ASSERT: 2,
});
